import moveToOrder from './moveToOrder';
import HoldPositionOrder from './holdPositionOrder';

import {
  getAngleBy2XY,
  getDiffBetween2Angles,
  getDistanceBy2XY,
} from '../../utils/geometry';


export default class StrafeToOrder extends moveToOrder {

  constructor(params: { x: number, y: number }) {
    super(params);
    this.color = 'yellow';
  }

  update(modifier: number): StrafeToOrder {
    const element = this.getElement();
    const {
      x,
      y,
      moveSpeed,
    } = element;

    if (moveSpeed > 0)
      element.stop();

    const destinationAngle = getAngleBy2XY({
      x1: x,
      y1: y,
      x2: this.x,
      y2: this.y,
    });

    /* strafe order for ships unable to strafe mean "rotate towards this angle" */
    if (!element.canStrafe) {
      element.rotateTowardsAngle(destinationAngle, modifier);
      return this;
    }

    element.strafe(modifier, destinationAngle); // move towards desired location at strafing speed

    /* Keep shooting at closest target */
    const closestTarget = element.getNearestEnemy();
    if (!closestTarget)
      element.moveAngle = element.rotateTowardsAngle(destinationAngle, modifier);
    else {
      const angleBetweenElementAndTarget = getAngleBy2XY({
        x1: element.x,
        y1: element.y,
        x2: closestTarget.x,
        y2: closestTarget.y,
      });
      element.rotateTowardsAngle(angleBetweenElementAndTarget, modifier);
    }

    /* Reach the objective, don't overshoot it */
    if (this.isComplete(modifier)) {
      element.x = this.x;
      element.y = this.y;
    }

    return this;
  }

  isComplete(modifier: number): boolean {
    const { x, y, lookAngle } = this.getElement();
    if (!this.getElement().canStrafe) {
      const destinationAngle = getAngleBy2XY({
        x1: x,
        y1: y,
        x2: this.x,
        y2: this.y,
      });
      return (getDiffBetween2Angles(lookAngle, destinationAngle) <= 1);
    }

    /* element is gonna overshoot its destination */
    const distanceToObjective = getDistanceBy2XY({
      x1: x,
      y1: y,
      x2: this.x,
      y2: this.y,
    });
    return (distanceToObjective < this.getElement().strafeSpeed * modifier);
  }

  onComplete(): void {
    /* Non-strafing ships have an additional HoldPosition order given after this one */
    const element = this.getElement();
    if (!element.canStrafe && element.behaviour)
      element.behaviour.queueOrder(new HoldPositionOrder());
  }

  isPossible(): boolean {
    return (this.getElement()?.strafeSpeed > 0);
  }
}
